import {fabric} from 'fabric';

const capitalize = (text) => {
  const words = text.split(' ');
  return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};

export const letterCasing = {
  capitalize,
  upper: (text) => text.toUpperCase(),
  lower: (text) => text.toLowerCase(),
};

const letterCasingHandler = (operation, text) => (operation ? letterCasing[operation](text) : text);

fabric.util.object.extend(fabric.Textbox.prototype, {
  enterEditing() {
    if (this.hiddenTextarea) {
      this.text = this.hiddenTextarea.value;
    } else {
      // eslint-disable-next-line no-underscore-dangle
      this.text = this._originalText ?? this.text;
    }
    this.callSuper('enterEditing');
    return this;
  },
  exitEditing() {
    // eslint-disable-next-line no-underscore-dangle
    this._originalText = this.text;
    this.text = letterCasingHandler(this.letterCasing, this.text);
    this.callSuper('exitEditing');
    return this;
  },
});
